import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type ProductType = {
  sizeType: string;
  options: any;
};

const initialState: ProductType = {
  sizeType: '',
  options: null,
};

export const productSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setSizeType: (state, action: PayloadAction<string>) => {
      state.sizeType = action.payload;
    },
    setOptions: (state, action) => {
      state.options = action.payload;
    },
  },
});

export const { setSizeType, setOptions } = productSlice.actions;

export default productSlice.reducer;
